<template>
     <v-footer
    absolute inset app height="200" width="auto" class="py-12"
  >
    <v-card
      class="flex"
      flat
      tile
    >
      <v-card-title class="primary">
        <h3>learn more:

        </h3>
          <a class="blue--text" href="http://www.badugaa.com">www.badugaa.com</a>
        <v-spacer></v-spacer>
        <marquee behavior="scroll" direction="left">
        <strong class="subheading red--text">Note: Site is under beta version!</strong>
        </marquee>

        <v-spacer></v-spacer>

        <v-btn
          v-for="icon in icons"
          disabled
          :key="icon"
          class="mx-3"
          dark
          icon
        >
          <v-icon size="24px">{{ icon }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-actions class="blue darken-3 justify-center">
          © {{ new Date().getFullYear() }} — <strong> ® All Rights Reserved</strong>
      </v-card-actions>
    </v-card>
  </v-footer>
</template>

<script>

export default {
  name: 'App',
  data: () => ({
    icons: [
      'fab fa-facebook',
      'fab fa-twitter',
      'fab fa-google-plus',
      'fab fa-linkedin',
      'fab fa-instagram',
    ],
  }),
};
</script>
